import { render } from "./RosterManager.vue?vue&type=template&id=0b442597&scoped=true"
import script from "./RosterManager.vue?vue&type=script&lang=js"
export * from "./RosterManager.vue?vue&type=script&lang=js"

import "./RosterManager.vue?vue&type=style&index=0&id=0b442597&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b442597"]])

export default __exports__